import { Colors } from '@zapier/design-system';

const NEW_ZAP_ID = 'new-zap';
const PRECONFZAPSHARING_BASE_URL = '/preconfigured-zaps/api/v1';
const MOBILE_BREAKPOINT = 500;
const MAX_WIDTH_SHARED_ZAP_LANDER_CONTENT = 970;
const FALLBACK_PRIMARY_COLOR = Colors.gray40;
const BORDER_RADIUS = '10px';
const DURATION = '100ms'; //These are colors that were only part of @zapier/theme and are not part of Zinnia.
//The styles that use them will have to be refactored to use @zapier/design-system.

const CUSTOM_COLORS = {
  batmobile: '#5f6c72',
  steel: '#969ea2',
  adamantium: '#dadfe2'
};
const SCREEN_SIZES = {
  desktop: 1200,
  desktopLarge: 1800,
  phone: 599,
  tabletLandscape: 900,
  tabletPortrait: 600
};
({
  custom: {
    base: {
      backgroundColor: Colors.transparent,
      color: Colors.black
    },
    disabled: {
      backgroundColor: Colors.transparent,
      color: Colors.gray40
    },
    hover: {
      backgroundColor: Colors.transparent,
      color: Colors.gray60
    },
    focus: {
      backgroundColor: Colors.transparent,
      outlineColor: Colors.ocean,
      color: Colors.ocean
    }
  }
});

export { BORDER_RADIUS as B, CUSTOM_COLORS as C, DURATION as D, FALLBACK_PRIMARY_COLOR as F, MAX_WIDTH_SHARED_ZAP_LANDER_CONTENT as M, NEW_ZAP_ID as N, PRECONFZAPSHARING_BASE_URL as P, SCREEN_SIZES as S, MOBILE_BREAKPOINT as a };
